import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { JQLBuilderProps } from '@atlassian/jira-jql-builder/src/common/types.tsx';
import JQLBuilder from '@atlassian/jira-jql-builder/src/main.tsx';
import type { JQLBuilderWithAIFilters$key } from '@atlassian/jira-relay/src/__generated__/JQLBuilderWithAIFilters.graphql';

export type Props = Omit<JQLBuilderProps, 'userPreferencesData'> & {
	fragmentKey: JQLBuilderWithAIFilters$key | null;
	isFilterRefinementEnabled?: boolean;
};

export const JQLBuilderWithAIFilters = ({
	fragmentKey,
	isFilterRefinementEnabled,
	...props
}: Props) => {
	const data = useFragment<JQLBuilderWithAIFilters$key>(
		graphql`
			fragment JQLBuilderWithAIFilters on JiraQuery {
				userPreferences(cloudId: $cloudId) @optIn(to: "JiraUserPreferences") {
					...main_jqlBuilder_JQLBuilder
				}
			}
		`,
		fragmentKey,
	);

	if (!isFilterRefinementEnabled) {
		return <JQLBuilder {...props} userPreferencesData={data?.userPreferences ?? null} />;
	}

	return null; // TODO: return FilterRefinement component
};
